import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import '../style/scroll-to-top.css';

const ScrollToTop: React.FC = () => {
    const { t } = useLanguage();
    const [isVisible, setIsVisible] = useState(false);
    const innerBarRef = useRef<HTMLSpanElement>(null);

    const translation = t as any;
    const goBackTopText = translation.BUTTONS?.goBackTop || 'Go Back Top';

    useEffect(() => {
        const handleScroll = () => {
            // Show/hide button based on scroll position
            if (window.pageYOffset > 500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }

            // Update inner bar width based on scroll progress (original script logic)
            if (innerBarRef.current) {
                const bodyHeight = document.body.scrollHeight;
                const scrollPos = window.innerHeight + window.pageYOffset;
                let percentage = (scrollPos / bodyHeight) * 100;
                if (percentage > 100) {
                    percentage = 100;
                }
                innerBarRef.current.style.width = percentage + '%';
            }
        };

        // Initial check
        handleScroll();

        // Listen for scroll events
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const target = e.currentTarget.getAttribute('data-target');
        
        // Original script uses jQuery animate, but we'll use smooth scroll
        if (target === 'html') {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <a
            href="#"
            data-target="html"
            className={`scroll-to-target scroll-to-top ${isVisible ? 'show' : ''}`}
            onClick={handleClick}
        >
            <span className="scroll-to-top__wrapper">
                <span ref={innerBarRef} className="scroll-to-top__inner"></span>
            </span>
            <span className="scroll-to-top__text">{goBackTopText}</span>
        </a>
    );
};

export default ScrollToTop;

